export const mergeNewDataAndOldData = (oldData, newData) => {
  return { ...oldData, ...newData };
};
